interface ContactInfoProps {
  formData: any;
  updateFormData: (field: string, value: string) => void;
}

export default function ContactInfo({ formData, updateFormData }: ContactInfoProps) {
  return (
    <section className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center">
          <i className="ri-phone-line text-sky-600 text-xl"></i>
        </div>
        <h2 className="text-xl font-semibold text-slate-800">İletişim Bilgileri</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Telefon */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Telefon <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={(e) => updateFormData('phone', e.target.value)}
            required
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="0555 123 45 67"
          />
        </div>

        {/* E-posta */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            E-posta <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={(e) => updateFormData('email', e.target.value)}
            required
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="ornek@email.com"
          />
        </div>

        {/* İl */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            İl
          </label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={(e) => updateFormData('city', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="İl giriniz"
          />
        </div>

        {/* İlçe */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            İlçe
          </label>
          <input
            type="text"
            name="district"
            value={formData.district}
            onChange={(e) => updateFormData('district', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="İlçe giriniz"
          />
        </div>
      </div>
    </section>
  );
}
